import { PdfTemplateWrapper } from "./pdf-template-wrapper";

export default function PdfTemplatesPage() {
  return <PdfTemplateWrapper />;
}
